import React, { useState, useEffect } from 'react';
import FormControl from '@mui/material/FormControl';
import { v4 as uuidv4 } from 'uuid';
import { Button, TextField, Grid, Typography } from '@mui/material';
import { JsonEditor } from 'json-edit-react'
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
const JSONForm = (props) => {
  const [templateJson, setTemplateJson] = useState(props.template_json);

  const [errorMsg, setErrorMsg] = useState('');
  const [updated, setUpdated] = useState(false)

  const useFormDisplay = props.useFormDisplay || false;

  useEffect( () => {
    if (!updated)
      setTemplateJson(props.template_json)
  }, [props.template_json]);
  

  const handleOnSubmit = (event) => {
    setUpdated(false)
    props.handleOnSubmit(templateJson);
    if (props.handleBack)
      props.handleBack(templateJson);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      default:
        const key1 = name.split("[")[0]
        const key2 = name.split("[")[1].split("]")[0]

        var main_obj_copy = Object.assign({}, templateJson)
        var nested_row_copy = Object.assign({}, templateJson[key1])
        main_obj_copy[key1] = nested_row_copy
        main_obj_copy[key1][key2] = value
        
        setTemplateJson(main_obj_copy)
    }
  };

  return (
    <div className="main-form">
      {errorMsg && <p className="errorMsg">{errorMsg}</p>}
      <FormControl >
        <Grid container>
          <Grid item xs={12}>
            <Typography id="modal-modal-title" component="div" variant="h4" fontWeight="fontWeightMedium">
              {props.title}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} mt={2}>
                {updated &&
                  <Button sx={{m: 2}} fullWidth onClick={()=> handleOnSubmit() } variant="contained" type="submit" className="submit-btn">
                    Save Updates 
                  </Button>
                }
            {!useFormDisplay &&
              <JsonEditor
              maxWidth={"100%"}
              data={ templateJson }
              setData={ (newData) => { setTemplateJson(newData); setUpdated(true)} } // optional
               />  
            }
          { useFormDisplay && Object.keys(templateJson).filter((k) => k[0] != "_").map((k) => 
          {
              const pretty_title = (x) => x.split('_') 
              .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
              .join(' ')
              const next_keys = Object.keys(templateJson[k])
              return (
              <>
                <Typography variant="h6" sx={{p: 2}} >
                  {pretty_title('' + k)}
                </Typography>
                {next_keys.map ((kk) =>
                  {

                      const element = templateJson[k][kk]
                      if (Array.isArray(element) || (typeof element === 'object' && element !== null)) {
                        const next_keys2 = Object.keys(templateJson[k][kk])
                        return  <Grid container spacing={2} m={2} xs={12}>
                        <h4>{k}[{kk}]</h4>
                        {next_keys2.map ((kkk) => <> 
                        <Grid item xs={12}>
                        <TextField
                          label={pretty_title(kkk)}
                          multiline={templateJson[k][kk][kkk].length> 60}
                          name={k + "[" + kk + "][" + kkk +"]"}
                          value={templateJson[k][kk][kkk]}
                          onChange={handleInputChange}
                          fullWidth
                        />
                      </Grid>
                      </>
                        )}
                        </Grid>
                      } 
                      else {
                        return (<Grid item xs={12}>
                        <TextField
                          label={pretty_title('' + kk)}
                          name={k + "[" + kk + "]"}
                          multiline={templateJson[k][kk].length> 60}
                          value={templateJson[k][kk]}
                          onChange={handleInputChange}
                          fullWidth
                        />
                      </Grid>)}
                      }
                )}
              </>)
          })}
          <Grid item xs={12}>
            {props.handleBack && 
              <Button variant="text" onClick={() => props.handleBack() } > 
                Cancel 
              </Button>
            }
            {updated &&
              <Button onClick={()=> handleOnSubmit() } variant="contained" type="submit" className="submit-btn">
                Save Updates 
              </Button>
            }
          </Grid>
        </Grid>
      </FormControl>
    </div>
  );
};

export default JSONForm;


